module.exports = __webpack_public_path__ + "img/heartofcare.587d757e.png";